import TokensComponent from '../components/tokens/TokensComponent';

export default function Tokens() {
  return <TokensComponent />;
}
